import Link from "next/link";
import { cx } from "class-variance-authority";
import { ArrowRightIcon } from "lucide-react";

export const LeverageCard = () => {
	return (
		<div className="relative overflow-hidden rounded-lg bg-[#30404D] p-6">
			<div className="mb-20">
				<h3 className="mb-5 text-xl text-white">
					Join the world’s top notch CEO community at{" "}
					<span className="font-extrabold">Leverage!</span>
				</h3>

				<p className="text-sm text-white">
					It is a long established fact that a reader will be distracted by the readable content of
					a page
				</p>
			</div>

			<Link
				href="https://leverage.up.railway.app/liverageThird.html"
				className={cx(
					"relative rounded-md bg-gray-50 p-3 text-center text-gray-900",
					"flex w-full items-center justify-center gap-2 text-sm font-medium font-semibold"
				)}
			>
				Visit Now <ArrowRightIcon className="h-4 w-4" />
			</Link>
		</div>
	);
};
